import React from "react";
import Anime from 'react-anime';
import RandomCircles from "../components/RandomCircles";
import vialImg from '../assets/photos/vials.png';
import { isMobile } from "react-device-detect";
export default ({ isActive }) => {
  const message = 'There are countless people around the world living with diseases for which there are no available effective treatments.';
  const subMessage = 'We need new medicines.';

  const slideInVials = {
    translateY: [
      { value: '100vh', duration: 0, delay: 1000 },
      { value: () => isMobile ? '3vh' : '15vh', duration: 1000, easing: 'easeOutSine' }
    ]
  }
  return (
    <div className="component second-component hide-overflow" style={{zIndex: 1}}>
      <div style={{flexDirection: 'column'}} className="text-container">
        <p className="secondary-large centered">{message}</p>
        <br></br>
        <p className="primary-large centered">{subMessage}</p>
      </div>
      {isActive && (<RandomCircles />)}
      {isActive && (
        <Anime {...slideInVials} className="vial-container">
          <img src={vialImg} alt="vials"/>
        </Anime>
      )}
    </div>
  );
};